import { useEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop() {
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  };
  useEffect(() => {
    onTop();
  }, [routePath]);

  return null;
}
